import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Input from '../components/Controls/Input'
import { sign_in_user } from '../firebase-services/auth-services'
import { getAuthFail, getAuthFetch, getAuthSuccess, selectIsLoading } from '../Redux/slices/authState'
import handleChange from '../Utils/HandleChange'
import {  toast } from 'react-toastify';
import { Help, MailLockOutlined, PasswordOutlined } from '@mui/icons-material'
export default function Login() {
    const dispatch = useDispatch()
    const isLoading = useSelector(selectIsLoading)
    const [loginForm,setLoginForm] = useState({
        email:"",
        password:"",
    })
    const changeHandler = handleChange(loginForm,setLoginForm)
    const handleSubmit = ()=>{
        dispatch(getAuthFetch())
        sign_in_user(loginForm).then((userCredential)=>{
            //console.log(userCredential.user.accessToken,userCredential.user.uid)
            dispatch(getAuthSuccess({
                accessToken: userCredential.user.accessToken,
                uid: userCredential.user.uid,
            }))
            toast.success("Logged In Successfully!")
        }).catch((e)=>{
            console.log(e.message)
            dispatch(getAuthFail({
                error: e.message
            }))
            toast.error("Failed To Login")
        })
    }
    return (
        <section className="text-gray-600 body-font flex gap-10 justify-center items-center w-full h-screen">
                <div className="px-4 py-4 rounded-lg bg-yellow-200 shadow-sm">
                    <h2 className='text-lg font-semibold'><Help color='#232323' width={8} height={8}/> Instruction</h2>
                    <p>Use following credentials to login</p>
                    <h3 className='font-semibold'><MailLockOutlined color='#232323' width={8} height={8}/> user100@gmail.com</h3>
                    <h3 className='font-semibold'><PasswordOutlined color='#232323' width={8} height={8} /> User12345</h3>
                </div>
                <form className="lg:w-1/4 md:w-1/2 bg-gray-100 rounded-lg p-8 flex flex-col w-full mt-10 md:mt-0">
                    <h2 className="text-gray-900 text-lg font-medium title-font mb-5">Sign In</h2>
                    <Input name={"email"} label="Email" type='text' onChange={changeHandler} autoComplete="email-address"/>
                    <Input name={"password"} label="Password" type='password' onChange={changeHandler} autoComplete="current-password"/>
                    <button disabled={isLoading} onClick={handleSubmit} className="text-white bg-indigo-500 border-0 py-2 px-8 focus:outline-none hover:bg-indigo-600 rounded text-lg">{isLoading?"Logging in...":"Login"}</button>
                </form>
        </section>
    )
}
